<template>
  <div>
    <div class="main-container">
      <div class="downloads-wrapper">
        <h1>Download server files</h1>
        <div class="downloads-table">
          <div class="downloads-table-row">
            <div>Windows 64bit</div>
            <a
              class="download-button butn butn--sm butn--red"
              href="http://dataminidayzserverfiles.dayz.com/win64.zip"
              >Download</a
            >
          </div>
          <div class="downloads-table-row">
            <div>Windows 32bit</div>
            <a
              class="download-button butn butn--sm butn--red"
              href="http://dataminidayzserverfiles.dayz.com/win32.zip"
              >Download</a
            >
          </div>
          <div class="downloads-table-row">
            <div>Linux 64bit</div>
            <a
              class="download-button butn butn--sm butn--red"
              href="http://dataminidayzserverfiles.dayz.com/linux64.zip"
              >Download</a
            >
          </div>
        </div>
        <br />
        <p style="width: 60%;">
          By downloading and using this software you agree with
          <router-link class="color--red" :to="{ name: SERVERS_TAC_PAGE_NAME }"
            >terms and conditions</router-link
          >.<br /><br />
          Supported browsers for hosting a server are the latest versions of
          Chrome, Firefox and Opera. It is currently not possible to host
          servers on a system running OSX.
        </p>
      </div>
    </div>
    <Subscription />
  </div>
</template>

<script>
import Subscription from "../partials/Subscription/Subscription";
import { SERVERS_TAC_PAGE_NAME } from "../../router/names";

export default {
  name: "Server",
  components: {
    Subscription
  },
  data() {
    return {
      SERVERS_TAC_PAGE_NAME
    };
  }
};
</script>

<style scoped></style>
